export default __webpack_public_path__ + "static/media/srm.ee4fa624.png";